// extracted by mini-css-extract-plugin
export var aboveInput = "_mq-0";
export var actionButton = "_mq-5";
export var actionButtonContainer = "_mq-1";
export var actionIcon = "_mq-6";
export var aiInfoContainer = "_mq-2";
export var attachmentWrapper = "_mq-7";
export var bold = "_mq-3";
export var checkIcon = "_mq-8";
export var clickingRecipientBar = "_mq-11";
export var commentThreadSwitch = "_mq-a";
export var draftImage = "_mq-b";
export var draftImageContainer = "_mq-c";
export var draftImages = "_mq-e";
export var editButton = "_mq-g";
export var editor = "_mq-f";
export var editorContainer = "_mq-y";
export var editorErrorTooltipWrapper = "_mq-9";
export var headerDivider = "_mq-h";
export var icon = "_mq-i";
export var info = "_mq-j";
export var internal = "_mq-n";
export var internalDivider = "_mq-k";
export var internalMessage = "_mq-l";
export var messageInputCard = "_mq-m";
export var messageInputForm = "_mq-o";
export var messageInputFormInternal = "_mq-p";
export var options = "_mq-q";
export var publicMessageCustomer = "_mq-s";
export var publicMessageMerchant = "_mq-r";
export var removeImageButton = "_mq-d";
export var replyButtons = "_mq-t";
export var showSignatureButton = "_mq-u";
export var spinner = "_mq-v";
export var verticalButtonDivider = "_mq-4";
export var visibilitySelector = "_mq-w";
export var warning = "_mq-x";
export var wrappingText = "_mq-z";
export var writingInternalNoteTopBorder = "_mq-10";